import { createContext, useState, useContext } from 'react';

const initialSalesUnit = "";
const initialUnit = "Value";
const SalesContext = createContext();
export const SalesProvider = ({ children }) => {
  const [selectedMRs, setSelectedMRs] = useState([]);
  const [userRole, setuserRole] = useState();
  const [userID, setuserID] = useState();
  const [kpiData, setKpiData] = useState({});
  const [newFilterdata, setNewFilterdata] = useState({});
  const [secondaryKpiData, setSecondaryKpiData] = useState({}); 
  const [salesUnit, setSalesUnit] = useState(initialSalesUnit); 
  const [unit, setUnit] = useState(initialUnit);
  const [showatable,setShowtable]=useState(false)
  const [loading, setLoading] = useState(true);

  const updateKpiData = (newData) => {
    setKpiData(prev => ({
      ...prev,
      kpi_data: {
        ...prev["kpi_data"],
        ...newData
      }
    }));
  };

  
  const updateSalesUnit = (newUnit) => {
    setSalesUnit(newUnit);
  };

 
  const contextValue = {
    selectedMRs,
    kpiData,
    salesUnit,
    setSelectedMRs,
    setLoading,
    updateKpiData,
    updateSalesUnit,
    unit,
    setKpiData,      
    setSalesUnit,
    setUnit,
    loading,
    setNewFilterdata
    ,newFilterdata,
    showatable,
    setShowtable,
    setuserRole,
    userRole,
    setSecondaryKpiData
    ,secondaryKpiData,
    setuserID,
    userID
  };

  return (
    <SalesContext.Provider value={contextValue}>
      {children}
    </SalesContext.Provider>
  );
};

export const useSalesContext = () => {
  const context = useContext(SalesContext);
  if (!context) {
    throw new Error('useSalesContext must be used within a SalesProvider');
  }
  return context;
};

export default SalesContext;